import React from "react";
import SVGraphics from "../../../assets/SVGraphics";
import { useViewer } from "./context/ViewerContext";
import { SlideInput } from "../../../components/input/SlideInput";

const TOOL_ICONS = [
  "MouseIcon",
  "HandIcon",
  "TriangleMeasurementIcon",
  "MeasurementIcon",
];

//  "ProbeOnly",

const Header = ({ dicomData, patientId, onSplitClick,goBackToMenu }) => {
  const {
    activeTool,
    setActiveTool,
    zoom,
    setZoom,
    notesOpen,
    splitState,
    setNotesOpen,
    graphOpen,
    setGraphOpen,
    setSplitState,
  } = useViewer();

  const handleSelectIcon = (iconName) => {
    setActiveTool((prev) => (prev === iconName ? null : iconName));
  };

  const [toggleValue, setToggleValue] = React.useState(1);

  const handleToggleChange = (name, value) => {
    setToggleValue(value);
    setActiveTool(value === 1 ? "AllColors" : "ProbeOnly");
  };

  return (
    <div className="w-full h-[63px] box-border bg-[black] p-4 flex items-center relative">
      {/* Left: Tools */}
      <div className="flex gap-3">
        {/* BackButton */}       
        <SVGraphics
          className="w-7 h-7 cursor-pointer"
          svgname={
            activeTool ===" BackButton" ? "BackButton" : "BackButton"
          }
          onClick={() => goBackToMenu()}
        />

        {/* Separator */}
        <div className="w-[1px] h-7 bg-[#484848] mx-2" />

        {/* Mouse */}
        <SVGraphics
          className="w-7 h-7 cursor-pointer"
          svgname={
            activeTool === "MouseIcon" ? "MouseIconSelected" : "MouseIcon"
          }
          onClick={() => setActiveTool("MouseIcon")}
        />

        {/* Hand */}
        <SVGraphics
          className="w-7 h-7 cursor-pointer"
          svgname={activeTool === "HandIcon" ? "HandIconSelected" : "HandIcon"}
          onClick={() => setActiveTool("HandIcon")}
        />

        {/* Triangle Measurement */}
        <SVGraphics
          className="w-7 h-7 cursor-pointer"
          svgname={
            activeTool === "TriangleMeasurementIcon"
              ? "TriangleMeasurementIconSelected"
              : "TriangleMeasurementIcon"
          }
          onClick={() => setActiveTool("TriangleMeasurementIcon")}
        />
        {/* Grid = independent layout toggle (NOT part of TOOL_ICONS) */}
        <SVGraphics
          className="w-7 h-7 cursor-pointer"
          svgname={splitState !== "off" ? "GridIconSelected" : "GridIcon"}
          onClick={() => {
            if (splitState === "off") {
              onSplitClick && onSplitClick(); // parent runs preflight + loading
            } else {
              setSplitState("off"); // exit split
            }
          }}
        />

        {/* Measurement (filter/tool) */}
        <SVGraphics
          className="w-7 h-7 cursor-pointer"
          svgname={
            activeTool === "MeasurementIcon"
              ? "MeasurementIconSelected"
              : "MeasurementIcon"
          }
          onClick={() => setActiveTool("MeasurementIcon")}
        />

        {/* Zoom select */}
        <select
          id="zoomSelect"
          value={zoom}
          onChange={(e) => setZoom(Number(e.target.value))}
          className="w-17 h-8 px-2 py-1 bg-[#333] rounded-lg text-xs text-white cursor-pointer">
          {[1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 2.75, 3].map((val) => (
            <option key={val} value={val}>{`${val * 100}%`}</option>
          ))}
        </select>

        <div>
          <SlideInput
            name="headerToggle"
            value={toggleValue}
            onChange={handleToggleChange}
            step={1}
            rightLabel="Show All Colors"
            marginTop="mt-2"
            min={0}
            max={1}
          />
        </div>
      </div>

      {/* Center: Patient Info */}
      <div className="absolute left-1/2 transform -translate-x-1/2">
        <label className="text-white text-sm">
          {`Patient ID ${patientId} / Case ${dicomData?.caseId || "N/A"}`}
        </label>
      </div>

      <div className="ml-auto flex items-center gap-2">
        {splitState === "on" ? (
          <SVGraphics
            className="w-7 h-7 cursor-pointer pointer-events-auto"
            svgname={graphOpen ? "SplitNotesIconSelected" : "SplitNotesIcon"}
            onClick={() => setGraphOpen(!graphOpen)}
          />
        ) : splitState === "loading" ? null : (
          <SVGraphics
            className="w-7 h-7 cursor-pointer"
            svgname={notesOpen ? "NotesIconSelected" : "NotesIcon"}
            onClick={() => setNotesOpen(!notesOpen)}
          />
        )}
      </div>
    </div>
  );
};

export default Header;
